import e from"react";var t=e.createContext({isOpen:!1,onClick:null,onBlur:null,controlled:!1,alignment:"",triggerHeight:0,setTriggerHeight:null,triggerWidth:0,setTriggerWidth:null,triggerRef:null,contentRef:null});export{t as default};
